import React from 'react'
import FormPage from '../layout/FormPage'
import { TextField } from '@mui/material'

const Token = () => {
  const handleUpdate = (token: string) => {
    localStorage.setItem('token', token)
  }

  return (
    <FormPage title='Update Token'>
      <TextField
        label='Twilio Token'
        onChange={(e) => handleUpdate(e.target.value)}
      />
    </FormPage>
  )
}

export default Token
